module.exports = __webpack_public_path__ + "img/filter-icon.6fe54cf9.svg";